import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.13276aca.css";
import "./index.0e7756c7.css";
import OutstandingInvoices from "./OutstandingInvoices";
import PastPayments from "./PastPayments";
import {
  GetFileandAssociatedLawyerByAssistant,
  GetFirmInvoicesExpress,
  GetFirmInvoicesTotal,
  GetReviewPayments,
  invoiceSelector,
  setInvoiceFilters,
  setInvoiceFilterValue,
} from "../../features/invoice/invoiceSlice";
import { getLawfirmForInternalUser } from "../../common/utils";
import Loader from "../orderStatus/Loader";
import { useTranslation } from "react-i18next";

function OrderInvoices({
  location,
  firmIDAndName,
  DashboardLawfirm,
  userLogin,
  showOutstanding,
  setshowOutstanding,
}) {
  const [isPayInvoices, setIsPayInvoices] = useState(false);
  const { pastPayments } = useSelector(invoiceSelector);


  const firmID = getLawfirmForInternalUser(
    firmIDAndName,
    DashboardLawfirm,
    userLogin?.internalUser
  );
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const dispatch = useDispatch();
  const [showInvoiceSummary, setShowInvoiceSummary] = useState(false);
  const [payCheckedInvoices, setspayCheckedInvoices] = useState(false);

  useEffect(() => {
    getOutstandingInvoices();
    getPastPayments();
  }, [firmID, currentLanguage]);

  useEffect(() => {
    if (
      location &&
      location?.state &&
      location?.state?.Tab &&
      location?.state?.Tab === 4 &&
      location?.state?.SubTab
    ) {
      if (location?.state?.SubTab === 1) {
        setshowOutstanding(true);
      } else if (location?.state?.SubTab === 2) {
        setshowOutstanding(false);
      }
    }
  }, [location]);

  const getOutstandingInvoices = (data) => {
    dispatch(
      GetFirmInvoicesExpress(
        data
          ? {
            ...data,
            SelectedFilelanguage: currentLanguage === "en" ? "en-CA" : "fr-CA",
            isLawyer: userLogin?.isLawyer,
            isInternalUser: userLogin?.internalUser,
          }
          : {
            FirmID: firmID,
            Paid: false,
            userID: userLogin?.userId,
            commercial: 2,
            Lawyer: "",
            closeDate: "",
            DateRangeStart: "",
            DateRangeEnd: "",
            BillingType: "",
            SelectedFilelanguage: currentLanguage === "en" ? "en-CA" : "fr-CA",
            SearchText: "",
            SortColumn: "",
            SortOrder: "",
            TotalRangeStart: null,
            TotalRangeEnd: null,
            pageNumber: 1,
            isLawyer: userLogin?.isLawyer,
            isInternalUser: userLogin?.internalUser,
          }
      )
    );
    dispatch(
      GetFirmInvoicesTotal(
        data
          ? { ...data, isLawyer: userLogin?.isLawyer, isInternalUser: userLogin?.internalUser }
          : {
            FirmID: firmID,
            Paid: false,
            userID: userLogin?.userId,
            commercial: 2,
            Lawyer: "",
            DateRangeStart: "",
            DateRangeEnd: "",
            BillingType: "",
            paymentMethod: "",
            SelectedFilelanguage: "",
            SearchText: "",
            TotalRangeStart: null,
            TotalRangeEnd: null,
            isLawyer: userLogin?.isLawyer,
            isInternalUser: userLogin?.internalUser,
          }
      )
    );
    dispatch(GetFileandAssociatedLawyerByAssistant(userLogin?.userId));
  };
  const getPastPayments = (data) => {
    let lawyer = data?.lawyerID?.toString() === "All" ? "-1" : data?.lawyerID?.toString();
    dispatch(
      GetReviewPayments({
        firmID: firmID,
        lawyerID: lawyer || "-1",
        userID: userLogin?.userId,
        dateRangeStart: data?.dateRangeStart || "",
        dateRangeEnd: data?.dateRangeEnd || "",
        paymentMethod: data?.paymentMethod || "",
        searchText: data?.searchText || "",
        sortColumn: data?.sortColumn || "",
        sortOrder: data?.sortOrder || "",
        totalRangeStart: data?.totalRangeStart || null,
        totalRangeEnd: data?.totalRangeEnd || null,
        pageNumber: data?.pageNumber || 1,
        isLawyer: userLogin?.isLawyer,
        isInternalUser: userLogin?.internalUser,
      })
    );
  };
  return (
    <div>
      {!isPayInvoices && !showInvoiceSummary && !payCheckedInvoices && (
        <div className="flex mb-[40px]">
          <button
            className={
              (showOutstanding
                ? "!bg-primary-yellow-100"
                : "!border-primary-yellow") +
              " border-2 btn__secondary font-semibold h-[35px] mr-4 rounded-sm w-auto pl-2 pr-2"
            }
            onClick={() => {
              setshowOutstanding(true);
              dispatch(setInvoiceFilters(false));
              dispatch(setInvoiceFilterValue([]));
            }}
          >
            {t("OutstandingInvoices")}
          </button>
          <button
            type="button"
            onClick={() => {
              setshowOutstanding(false);
              dispatch(setInvoiceFilters(false));
              dispatch(setInvoiceFilterValue([]));
            }}
            className={
              (!showOutstanding
                ? "!bg-primary-yellow-100"
                : "!border-primary-yellow") +
              " border-2 btn__secondary font-semibold h-[35px rounded-sm w-auto pl-2 pr-2"
            }
          >
            {t("ReviewPayments")}
          </button>
        </div>
      )}
      {showOutstanding && !showInvoiceSummary && !payCheckedInvoices &&
        <h1 className="font-bold mb-[24px] w-[1125px]">
          {t("MakeaPaymentDescription1")}
          <br />
          <br />
          {t("MakeaPaymentDescription2")}
        </h1>
      }

      {showOutstanding ? (
        <OutstandingInvoices
          setshowOutstanding={setshowOutstanding}
          setIsPayInvoices={(data) => setIsPayInvoices(data)}
          getOutstandingInvoices={getOutstandingInvoices}
          firmID={firmID}
          userId={userLogin?.userId}
          isLawyer={userLogin?.isLawyer}
          showInvoiceSummary={showInvoiceSummary}
          setShowInvoiceSummary={setShowInvoiceSummary}
          payCheckedInvoices={payCheckedInvoices}
          setspayCheckedInvoices={setspayCheckedInvoices}
          isInternalUser={userLogin?.internalUser}
          firmIDAndName={firmIDAndName}
          DashboardLawfirm={DashboardLawfirm}
        />
      ) : (
        <PastPayments
          setshowOutstanding={setshowOutstanding}
          pastPayments={pastPayments}
          getPastPayments={getPastPayments}
          isLawyer={userLogin?.isLawyer}
          isInternalUser={userLogin?.internalUser}
        />
      )}
    </div>
  );
}

export default OrderInvoices;
